import React from 'react';
import { ReactQueryProvider } from '@iziping/ui';
import logo from '../assets/iziping_logo_750px.png';

const TournamentQueryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <ReactQueryProvider logo={logo}>{children}</ReactQueryProvider>
);

export default TournamentQueryProvider;
